import { CmsAppearanceHint } from "@/components/cms/theme/CmsAppearanceHint";
import { CmsPageBackgroundField } from "@/components/cms/theme/CmsPageBackgroundField";
import { CmsPageTypographyField } from "@/components/cms/theme/CmsPageTypographyField";
import { CmsPageTextColorField } from "@/components/cms/theme/CmsPageTextColorField";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

type Props = {
  formPrefix?: string;
  className?: string;
};

/** Paramètres fond / typo communs à toutes les langues de la page (pas de colonnes FR/EN). */
export function CmsPageAppearanceSettings({ formPrefix, className }: Props) {
  const { t } = useTranslation();

  return (
    <div className={cn("flex w-full max-w-2xl flex-col gap-4", className)}>
      <CmsAppearanceHint>{t("cms.page.settings.allLocalesHint")}</CmsAppearanceHint>
      <CmsPageTypographyField formPrefix={formPrefix} />
      <CmsPageBackgroundField formPrefix={formPrefix} />
      <CmsPageTextColorField formPrefix={formPrefix} />
    </div>
  );
}
